import request from '@/utils/http'

/**
 * 应用列表
 * @param payload
 */
export function order_all_status(payload) {
    return request({ url: '/Order/orderAllStatus', method: 'post', data: payload })
}